import "./App.css";

import MainRoute from "./route/Route";

function App() {
  return (
    <div>
      <MainRoute />
    </div>
  );
}

export default App;
